module.exports = __webpack_public_path__ + "static/img/guozhiyinliao.50c8a55.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/type/daohang/guozhiyinliao.png
// module id = 20ge
// module chunks = 12